import FluidHeader from './FluidHeader'
import MobileMenu from './MobileMenu'
import LazyLoad from 'vanilla-lazyload'
import initRandom from './RandomEmployee'
import initScrollSlide from './ScrollSlide'
import initSwiper from './Swiper'
import Flip from './Button'
import initScrollStickyCards from './ScrollStickyCards'
import CurrentElement from './CurrentElement'
import FloatSlider from './FloatSlider'
import SliderImages from './SliderImages'
import Accordion from './Accordion'
import Breadcrumb from './Breadcrumb'
import FilterOffers from './FilterOffers'
import AutoScroll from './AutoScroll'
import FixedButton from './FixedButton'
import AjaxsScript from './AjaxsScript'
import FancyboxInit from './FancyboxInit'

window.addEventListener('load', () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  if (window.location.hash) {
    const targetId = decodeURIComponent(window.location.hash)
    const element = document.querySelector(targetId)

    if (element) {
      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        })
      }, 100)
    }
  } else {
    window.scrollTo(0, 0)
  }
})

$(document).ready(() => {
  const myLazyLoad = new LazyLoad()
  FancyboxInit()
  MobileMenu()
  FluidHeader()
  initScrollSlide()
  initRandom()
  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      initScrollSlide()
    }, 300)
  })
  initSwiper()
  Flip()
  initScrollStickyCards()
  CurrentElement()
  FloatSlider()
  SliderImages()
  Accordion()
  Breadcrumb()
  FilterOffers()
  AutoScroll()
  FixedButton()
  AjaxsScript()
})
